import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.editServiceCost.title',
    defaultMessage: 'Edit service cost',
    description: 'title of the edit service cost page',
  },
  cancelDialog: {
    title: {
      id: 'pages.editServiceCost.cancelDialog.title',
      defaultMessage: 'Cancel editing service cost',
      description: 'title of the cancel edit service cost dialog',
    },
    description: {
      id: 'pages.editServiceCost.cancelDialog.description',
      defaultMessage:
        'Are you sure you would like to stop editing the current service cost? All changes will be undone.',
      description: 'title of the cancel edit service cost dialog',
    },
    actions: {
      cancel: {
        id: 'pages.editServiceCost.cancelDialog.actions.cancel',
        defaultMessage: 'Cancel',
        description: 'label of the cancel button in the cancel edit service cost dialog',
      },
      ok: {
        id: 'pages.editServiceCost.cancelDialog.actions.ok',
        defaultMessage: 'Ok',
        description: 'label of the ok button in the cancel edit service cost dialog',
      },
    },
  },
  breadcrumbs: {
    serviceCosts: {
      id: 'pages.editServiceCost.breadcrumbs.serviceCosts',
      defaultMessage: 'Service costs',
      description: 'Label of the service costs breadcrumb of the edit service cost page',
    },
    edit: {
      id: 'pages.editServiceCost.breadcrumbs.edit',
      defaultMessage: 'Edit',
      description: 'Label of the edit breadcrumb of the edit service cost page',
    },
  },
  feedback: {
    serviceCostUpdated: {
      id: 'pages.editServiceCost.feedback.serviceCostUpdated',
      defaultMessage: 'service cost updated',
      description: 'service updated success message',
    },
    serviceCostNotUpdated: {
      id: 'pages.editServiceCost.feedback.serviceCostNotUpdated',
      defaultMessage: 'service cost could not be updated',
      description: 'service updated error message',
    },
  },
};

export default defineMessages(translations);
